import { useOutletContext, useNavigate, } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaClipboardList } from "react-icons/fa";
import GroupSecondary from "../pages/SecGroupList";
import "../styles/ledger.css";
import * as services from "../api/services";

/* ================= GROUP TREE ================= */
const GROUP_TREE = [
  {
    name: "Current Assets",
    children: [
      { name: "Bank Accounts" },
      { name: "Cash in Hand" },
      { name: "Sundry Debtors" },
      { name: "Deposits" },
      { name: "Loan & Advances"},
      { name: "Stock in hand"}
    ]
  },
  {
    name: "Liabilities",
    children: [
      { name: "Capital Account" },
      { name: "Sundry Creditors" },
      { name: " Bank OD/Occ Alc"},
      { name: "Secured loans"},
      { name: "Unsecured loans"},
      { name: "Duties & Taxes"},
      { name: "Provisions"},
      { name: "Payables"}

    ]
  },
  {
    name : "Trading Account",
    children :[
      {name : "Opening Stock"},
      {name : "Purchase Account"},
      {name : "Direct Expenses"},
      {name : "Sales Account"},
      {name : "Direct income"},
      {name : "closing stock"},
      {name:"Gross profit"}
    ]
  },
  {
    name : "Profit & Loss Account",
    children:[
      {name : "Indirect Expenses"},
      {name : "Indirect Income"},
      {name : "Nett Profit"}

    ]
  }
];

/* ================= FLATTEN ================= */
const flattenGroups = (tree, depth = 0) => {
  let result = [];
  tree.forEach(node => {
    result.push({ name: node.name, depth });
    if (node.children) {
      result = result.concat(flattenGroups(node.children, depth + 1));
    }
  });
  return result;
};


const GROUP_LIST = flattenGroups(GROUP_TREE);


/* ================= GROUP TYPE ================= */
const getGroupType = (group) => {
  if (group === "Bank Accounts") return "bank";
  if (group === "Sundry Debtors") return "sundrydebtor";
  if (group === "Sundry Creditors") return "creditor";
  if (group === "Loan & Advances") return "loanadvance";
  if (group === "Secured loans") return "secureloans";
  if (group === "Unsecured loans") return "unsecureloans";
  if (group === "Duties & Taxes") return "tax";
  if (group === "Provisions") return "Provisions";

  return "basic";
};

/* ================= ACCOUNT TYPE ================= */
const mapRegTypeToGstType = (regType) => {
  const map = {
    "Regular": "REGISTERED_BUSINESS_REGULAR",
    "Composition": "REGISTERED_BUSINESS_COMPOSITION",
    "Unregistered / Consumer": "UNREGISTERED",
    "Government Entity / TDS": "UNREGISTERED",
    "Regular - SEZ": "REGISTERED_BUSINESS_REGULAR",
    "Regular - Exports (EOU)": "REGISTERED_BUSINESS_REGULAR",
    "E-Commerce Operator": "REGISTERED_BUSINESS_REGULAR",
    "Input Service Distributor": "REGISTERED_BUSINESS_REGULAR",
    "Embassy / UN Body": "UNREGISTERED",
    "Non Resident Taxpayer": "UNREGISTERED",
  };
  return map[regType] || "UNREGISTERED";
};

const mapGroupToAccountType = (group) => {
  const g = (group || "").toLowerCase();
  if (
    ["bank accounts", "cash in hand", "sundry debtors", "deposits",
     "loan & advances", "stock in hand", "opening stock", "closing stock"]
      .some((x) => g.includes(x))
  ) return "ASSET";
  if (
    ["capital account", "sundry creditors", "bank od", "secured loans",
     "unsecured loans", "duties & taxes", "provisions", "payables"]
      .some((x) => g.includes(x))
  ) return "LIABILITY";
  if (
    ["sales account", "direct income", "gross profit", "indirect income", "nett profit"]
      .some((x) => g.includes(x))
  ) return "REVENUE";
  if (
    ["purchase account", "direct expenses", "indirect expenses"]
      .some((x) => g.includes(x))
  ) return "EXPENSE";
  return "ASSET";
};

export default function LedgerCreate() {
  const { collapsed } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const defaultGroup = location.state?.defaultGroup;
  const [showGroupModal, setShowGroupModal] = useState(false);

  const [groupList, setGroupList] = useState(GROUP_LIST);
  useEffect(() => {
  if (defaultGroup) {
    setLedger(prev => ({
      ...prev,
      group: defaultGroup
    }));
  }
}, [defaultGroup]);

  /* ================= STATE ================= */
  const [ledger, setLedger] = useState({
    name: "",
    address: "",
    group: "",
    mailingName: "",

    // BANK
    accHolder: "",
    accNo: "",
    ifsc: "",
    Swiftcode: "",
    bankName: "",
    branch: "",
    bankConfig: "No",

     // GST / DEBTOR
    gstin: "",
    billByBill: "Yes",
    creditPeriod: "",
    creditCheck: "No",
    contactPerson: "",
    mobile: "",
    email: "",
    state: "Uttar Pradesh",

    // loan & advance

    assests : "",
    appropiate: "",
    method : "",

     dutyType: "Others",   // Others | GST
  taxType: "IGST",      // IGST | CGST | SGST | CESS
  percentage: "",
  roundingMethod: "Not Applicable",
  includeAssessable: "Not Applicable",
  regType: "Regular"    // GST registration type
  });



  const [showGroup, setShowGroup] = useState(false);
  const [groupIndex, setGroupIndex] = useState(0);

  /* ================= AUTO SYNC ================= */
  useEffect(() => {
    setLedger(prev => ({
      ...prev,
      mailingName: prev.name
    }));
  }, [ledger.name]);
  useEffect(() => {
  const handleClickOutside = (e) => {
    // अगर group panel open है और click panel के बाहर हुआ
    if (showGroup) {
      const panel = document.querySelector(".ledger-group-panel");
      const modal = document.querySelector(".group-modal-box");

      if (panel && !panel.contains(e.target) && (!modal || !modal.contains(e.target))) {
        setShowGroup(false);   // 🔥 CLOSE DROPDOWN
      }
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showGroup]);

  /* ================= KEYBOARD NAV ================= */
  const handleGroupKeys = (e) => {
    if (!showGroup) return;

    if (e.key === "ArrowDown") {
      setGroupIndex(prev => (prev + 1) % GROUP_LIST.length);
    }

    if (e.key === "ArrowUp") {
      setGroupIndex(prev =>
        prev === 0 ? GROUP_LIST.length - 1 : prev - 1
      );
    }

    if (e.key === "Enter") {
      setLedger(prev => ({
        ...prev,
        group: GROUP_LIST[groupIndex].name
      }));
      setShowGroup(false);
    }

    if (e.key === "Escape") {
      setShowGroup(false);
    }
  };
  const handleGetGSTDetails = async () => {
    const isValidGST = (gst) => {
      const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;
      return regex.test(gst);
    };

    if (!isValidGST(ledger.gstin)) {
      alert("Invalid GSTIN");
      return;
    }

    try {
      const res = await services.lookupGst(ledger.gstin);
      const data = res.data;

      if (data.success) {
        setLedger(prev => ({
          ...prev,
          name: data.company_name || "",
          address: data.address || "",
          contactPerson: data.contact_person || "",
          mobile: data.contact_no || "",
          email: data.email || "",
          state: data.state || ""
        }));
      } else {
        alert("GST not found");
      }

    } catch (err) {
      console.error(err);
      alert("GST lookup failed: " + (err.response?.data?.detail || err.message));
    }
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!ledger.name.trim()) {
      alert("Please enter a ledger name");
      return;
    }

    if (!ledger.group) {
      alert("Please select a group for the ledger");
      return;
    }

    try {
      const group = ledger.group;
      if (group === "Sundry Debtors" || group === "Sundry Creditors") {
        await services.createParty({
          name: ledger.name.trim(),
          party_type: group === "Sundry Debtors" ? "CUSTOMER" : "VENDOR",
          gst_type: mapRegTypeToGstType(ledger.regType),
          gstin: ledger.gstin || "",
          billing_address: ledger.address || "",
          phone: ledger.mobile || "",
          email: ledger.email || "",
          state: ledger.state || "",
        });
        alert("Party created successfully");
        navigate(group === "Sundry Debtors" ? "/customers" : "/vendors");
      } else {
        await services.createAccount({
          name: ledger.name.trim(),
          account_type: mapGroupToAccountType(group),
        });
        alert("Ledger created successfully");
        navigate(-1);
      }
    } catch (err) {
      console.error(err);
      const data = err.response?.data;
      const detail =
        (typeof data === "string" && data) ||
        (Array.isArray(data) && data[0]) ||
        data?.detail ||
        data?.name?.[0] ||
        err.message ||
        "Failed to save ledger";
      alert(detail);
    }
  };

  /* ================= gst-rowUI ================= */
  return (
    <div className="ledger-app">
      <div className={`main-content ${collapsed ? "collapsed" : ""}`}>

        <div className="ledger-wrapper">

          {/* HEADER */}
          <div className="ledger-title-section">
            <div className="ledger-icon-box">
              <i className="fas fa-book"></i>
            </div>

            <div>
              <h2>Ledger Creation</h2>
            </div>
          </div>

          {/* TOP */}
          <div className="ledger-top">
            <div className="ledger-left-top">
              <div className="ledger-row">
                <label>Name</label>
                <input
                  value={ledger.name}
                  onChange={(e) =>
                    setLedger(prev => ({ ...prev, name: e.target.value }))
                  }
                />
              </div>

              <div className="add-ledger-row">
                <label>Address</label>
                <textarea
                  className="ledger-textarea"
                  value={ledger.address}
                  onChange={(e) =>
                    setLedger(prev => ({ ...prev, address: e.target.value }))
                  }
                  placeholder="Enter Address"
                />
              </div>
            </div>
            <div className="ledger-right-top">
               <div className="gst-row">
                <label>GSTIN</label>

                <input
                  maxLength={15}
                  value={ledger.gstin}
                  onChange={(e) =>
                    setLedger(prev => ({
                      ...prev,
                      gstin: e.target.value.toUpperCase()
                    }))
                  }
                />

                <button className ="gst-btn" onClick={handleGetGSTDetails}>
                  Get Details
                </button>

                <label>Ledger Code</label>
                <input />
              </div>

              {/* CUSTOMER INFO */}
              <div className="customer-grid">

                <div className="contact">
                  <label>Contact Person</label>
                  <input
                    value={ledger.contactPerson}
                    onChange={(e) =>
                      setLedger(prev => ({ ...prev, contactPerson: e.target.value }))
                    }
                  />
                </div>

                <div className="mobile">
                  <label>Mobile No.</label>
                  <input
                    value={ledger.mobile}
                    onChange={(e) =>
                      setLedger(prev => ({ ...prev, mobile: e.target.value }))
                    }
                  />
                </div>

                <div className="email">
                  <label>Email ID</label>
                  <input
                    value={ledger.email}
                    onChange={(e) =>
                      setLedger(prev => ({ ...prev, email: e.target.value }))
                    }
                  />
                </div>

              </div>

            </div>
          </div>

          <div className="ledger-divider"></div>

          {/* BOTTOM SPLIT */}
          <div className="ledger-bottom">

            {/* LEFT */}
            <div className="ledger-left">

              <div className="under-ledger-row">
                <label>Under</label>
                <input

                  value={ledger.group}
                  readOnly
                  placeholder="Select Group"
                  onClick={() => setShowGroup(true)}
                />
              </div>

              {/* 🔥 DYNAMIC FORM */}
              {getGroupType(ledger.group) === "bank" && (
                <div className="ledger-section">

                  <h3>Bank Account Details</h3>

                  <div className="ledger-line">
                    <span>A/c Holder</span><span>:</span>
                    <input
                      value={ledger.accHolder}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, accHolder: e.target.value }))
                      }
                    />
                  </div>

                  <div className="ledger-line">
                    <span>A/c No</span><span>:</span>
                    <input
                      value={ledger.accNo}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, accNo: e.target.value }))
                      }
                    />
                  </div>

                  <div className="ledger-line">
                    <span>IFSC</span><span>:</span>
                    <input
                      value={ledger.ifsc}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, ifsc: e.target.value }))
                      }
                    />
                  </div>
                  <div className="ledger-line">
                    <span>SWIFT CODE</span><span>:</span>
                    <input
                      value={ledger.Swiftcode}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, Swiftcode: e.target.value }))
                      }
                    />
                  </div>

                  <div className="ledger-line">
                    <span>Bank Name</span><span>:</span>
                    <input
                      value={ledger.bankName}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, bankName: e.target.value }))
                      }
                    />
                  </div>

                </div>
              )}
              
                 {getGroupType(ledger.group) === "tax" && (
                <div className="ledger-section">

                  <h3>Duties & Taxes</h3>

                  {/* TYPE */}
                  <div className="ledger-line">
                    <span>Type of Duty/Tax</span>
                    <span>:</span>
                    <select
                      value={ledger.dutyType}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, dutyType: e.target.value }))
                      }
                    >
                      <option>Others</option>
                      <option>GST</option>
                    </select>
                  </div>

                  {/* ================= OTHERS ================= */}
                  {ledger.dutyType === "Others" && (
                    <>
                      <div className="ledger-line">
                        <span>Percentage of calculation</span>
                        <span>:</span>
                        <input
                          value={ledger.percentage}
                          onChange={(e) =>
                            setLedger(prev => ({ ...prev, percentage: e.target.value }))
                          }
                        />
                      </div>

                      <h4>Statutory Details</h4>

                      <div className="ledger-line">
                        <span>Include in Assessable Value</span>
                        <span>:</span>
                        <select
                          value={ledger.includeAssessable}
                          onChange={(e) =>
                            setLedger(prev => ({
                              ...prev,
                              includeAssessable: e.target.value
                            }))
                          }
                        >
                          <option>Not Applicable</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                    </>
                  )}

                  {/* ================= GST ================= */}
                  {ledger.dutyType === "GST" && (
                    <>
                      <div className="ledger-line">
                        <span>Tax Type</span>
                        <span>:</span>
                        <select
                          value={ledger.taxType}
                          onChange={(e) =>
                            setLedger(prev => ({ ...prev, taxType: e.target.value }))
                          }
                        >
                          <option>IGST</option>
                          <option>CGST</option>
                          <option>SGST/UTGST</option>
                          <option>CESS</option>
                        </select>
                      </div>

                      <div className="ledger-line">
                        <span>Percentage</span>
                        <span>:</span>
                        <input
                          value={ledger.percentage}
                          onChange={(e) =>
                            setLedger(prev => ({ ...prev, percentage: e.target.value }))
                          }
                        />
                      </div>

                      <div className="ledger-line">
                        <span>Rounding Method</span>
                        <span>:</span>
                        <select
                          value={ledger.roundingMethod}
                          onChange={(e) =>
                            setLedger(prev => ({ ...prev, roundingMethod: e.target.value }))
                          }
                        >
                          <option>Not Applicable</option>
                          <option>Downward Rounding</option>
                          <option>Normal Rounding</option>
                          <option>Upward Rounding</option>
                        </select>
                      </div>
                    </>
                  )}

                </div>
              )}
              {getGroupType(ledger.group) === "loanadvance" && (
                <div className="ledger-section">
                  <h3>Loan & Advances</h3>
                  <div className="sundry-ledger-line">
                    <span>Inculde in Assessable Value calculation</span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.assests}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, assests: e.target.value }))
                      }>
                        <option>Not applicable</option>
                        <option>GST</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Appropriate to </span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.appropiate}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, appropiate: e.target.value }))
                      }>
                        <option>Goods</option>
                        <option>Goods and Services</option>
                        <option>Sevices</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Method of calculation </span>
                    <span>:</span>
                    <b>Based on value</b>
                  
                  </div>
                </div>
              )}
              {getGroupType(ledger.group) === "Provisions" && (
                <div className="ledger-section">
                  <h3>Provisions</h3>
                  <div className="sundry-ledger-line">
                    <span>Inculde in Assessable Value calculation</span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.assests}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, assests: e.target.value }))
                      }>
                        <option>Not applicable</option>
                        <option>GST</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Appropriate to </span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.appropiate}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, appropiate: e.target.value }))
                      }>
                        <option>Goods</option>
                        <option>Goods and Services</option>
                        <option>Sevices</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Method of calculation </span>
                    <span>:</span>
                    <b>Based on value</b>
                  
                  </div>
                </div>
              )}
              {getGroupType(ledger.group) === "secureloans" && (
                <div className="ledger-section">
                  <h3 className="sec-hed">Statutory details</h3>
                  <div className="sundry-ledger-line">
                    <span>Inculde in Assessable Value calculation</span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.assests}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, assests: e.target.value }))
                      }>
                        <option>Not applicable</option>
                        <option>GST</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Appropriate to </span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.appropiate}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, appropiate: e.target.value }))
                      }>
                        <option>Goods</option>
                        <option>Goods and Services</option>
                        <option>Sevices</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Method of calculation </span>
                    <span>:</span>
                    <b>Based on value</b>
                  
                  </div>
                </div>
              )}
              {getGroupType(ledger.group) === "unsecureloans" && (
                <div className="ledger-section">
                  <h3 className="sec-hed">Statutory details</h3>
                  <div className="sundry-ledger-line">
                    <span>Inculde in Assessable Value calculation</span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.assests}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, assests: e.target.value }))
                      }>
                        <option>Not applicable</option>
                        <option>GST</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Appropriate to </span>
                    <span>:</span>
                    <select className="sundryloan-tally-select"
                      value={ledger.appropiate}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, appropiate: e.target.value }))
                      }>
                        <option>Goods</option>
                        <option>Goods and Services</option>
                        <option>Sevices</option>
                    </select>
                  </div>
                  <div className="sundry-ledger-line">
                    <span>Method of calculation </span>
                    <span>:</span>
                    <b>Based on value</b>
                  
                  </div>
                </div>
              )}

              {getGroupType(ledger.group) === "sundrydebtor" && (
                <div className="ledger-section">
                  <h3>Sundry Debtors Details</h3>
                  {/* BILL BY BILL */}
                  <div className="sundry-ledger-line">
                    <span>Maintain balances bill-by-bill</span>
                    <span>:</span>
                    <select
                      className="sundry-tally-select"
                      value={ledger.billByBill}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, billByBill: e.target.value }))
                      }
                    >
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  {/* CREDIT PERIOD */}
                  <div className="sundry-ledger-line">
                    <span>Default credit period</span>
                    <span>:</span>
                    <input
                      className="sundry-tally-input"
                      placeholder="e.g. 30 Days"
                      value={ledger.creditPeriod}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, creditPeriod: e.target.value }))
                      }
                    />
                  </div>

                  {/* CREDIT CHECK */}
                  <div className="sundry-ledger-line">
                    <span>Check for credit days during voucher entry</span>
                    <span>:</span>
                    <select
                      className="sundry-tally-select"
                      value={ledger.creditCheck}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, creditCheck: e.target.value }))
                      }
                    >
                      <option>No</option>
                      <option>Yes</option>
                    </select>
                  </div>

                </div>
              )}
              {getGroupType(ledger.group) === "creditor" && (
                <div className="ledger-section">
                  <h3>Sundry Debtors Details</h3>
                  {/* BILL BY BILL */}
                  <div className="sundry-ledger-line">
                    <span>Maintain balances bill-by-bill</span>
                    <span>:</span>
                    <select
                      className="sundry-tally-select"
                      value={ledger.billByBill}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, billByBill: e.target.value }))
                      }
                    >
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  {/* CREDIT PERIOD */}
                  <div className="sundry-ledger-line">
                    <span>Default credit period</span>
                    <span>:</span>
                    <input
                      className="sundry-tally-input"
                      placeholder="e.g. 30 Days"
                      value={ledger.creditPeriod}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, creditPeriod: e.target.value }))
                      }
                    />
                  </div>

                  {/* CREDIT CHECK */}
                  <div className="sundry-ledger-line">
                    <span>Check for credit days during voucher entry</span>
                    <span>:</span>
                    <select
                      className="sundry-tally-select"
                      value={ledger.creditCheck}
                      onChange={(e) =>
                        setLedger(prev => ({ ...prev, creditCheck: e.target.value }))
                      }
                    >
                      <option>No</option>
                      <option>Yes</option>
                    </select>
                  </div>

                </div>
              )}

            </div>

            {/* RIGHT */}
            <div className="ledger-right">

              <div className="ledger-mailing">

                <h3>Mailing Details</h3>

                {/* <div className="ledger-line">
                  <span>Name</span><span>:</span>
                  <input value={ledger.mailingName} readOnly />
                </div>

                <div className="ledger-line">
                  <span>Address</span><span>:</span>
                  <input value={ledger.address} readOnly />
                </div> */}

                <div className="ledger-line">
                  <span>State</span><span>:</span>
                  <input
                    className="tally-input"
                    value={ledger.state}
                    onChange={(e) =>
                      setLedger(prev => ({ ...prev, state: e.target.value }))
                    }
                  />
                </div>

                <div className="ledger-line">
                  <span>Country</span><span>:</span>
                  <b>India</b>
                </div>
                {/* <div className="ledger-line">
                 <span>Pincode</span>
                 <span>:</span>
                 <input className="tally-input" />
               </div> */}
               {/* BANKING */}
               {/* <h4>Banking Details</h4> */}

               {/* <div className="ledger-line">
                 <span>Provide bank details</span>
                 <span>:</span>
                 <select className="tally-select">
                   <option>No</option>
                   <option>Yes</option>
                 </select>
               </div> */}
               {/* TAX */}
               <h4>Tax Registration Details</h4>

               <div className="ledger-line">
                 <span>PAN/IT No.</span>
                 <span>:</span>
                 <input className="tally-input" />
               </div>

               <div className="ledger-line">
                 <span>Registration type</span>
                 <span>:</span>
                 <select
                  value={ledger.regType}
                  onChange={(e) =>
                    setLedger(prev => ({ ...prev, regType: e.target.value }))
                  }
                 >
                  <option>Regular</option>
                  <option>Composition</option>
                  <option>Unregistered / Consumer</option>
                  <option>Government Entity / TDS</option>
                  <option>Regular - SEZ</option>
                  <option>Regular - Exports (EOU)</option>
                  <option>E-Commerce Operator</option>
                  <option>Input Service Distributor</option>
                  <option>Embassy / UN Body</option>
                  <option>Non Resident Taxpayer</option>
                 </select>
                 {/* <b>Regular</b> */}
               </div>

               {/* <div className="ledger-line">
                 <span>GSTIN/UIN</span>
                 <span>:</span>
                 <input className="tally-input" />
               </div>

               <div className="ledger-line">
                 <span>Set/Alter GST details</span>
                 <span>:</span>
                 <select className="tally-select">
                   <option>No</option>
                   <option>Yes</option>
                 </select>
               </div> */}

              </div>

            </div>

          </div>

          {/* FOOTER */}
          <div className="ledger-footer">
            <button className="led-save-btn" onClick={handleSave}>Save</button>
            <button className="led-cancel-btn" onClick={() => navigate(-1)}>Cancel</button>
          </div>

        </div>

        {/* 🔥 GROUP PANEL */}
        {showGroup && (
          <div
            className="ledger-group-panel"
            tabIndex={0}
            onKeyDown={handleGroupKeys}
          >
            <div className="list-group-header">
                <h3>List of Groups</h3>
                <button className="group-create-btn" onClick={() => setShowGroupModal(true)}>Create</button>

            </div>

            {GROUP_LIST.map((g, i) => (
              <div
                key={i}
                className={`group-item ${i === groupIndex ? "active" : ""}`}
                onClick={() => {
                  setLedger(prev => ({ ...prev, group: g.name }));
                  setShowGroup(false);
                }}
              >
                <span
                  className="group-text"
                  style={{ paddingLeft: `${g.depth * 20}px` }}
                >
                  {g.name}
                </span>

              </div>
            ))}
          </div>
        )}
        {showGroupModal && (
        <div
          className="group-modal-overlay"
          onClick={() => setShowGroupModal(false)}   // 🔥 outside click
        >
          <div
            className="group-modal-box"
            onClick={(e) => e.stopPropagation()}     // 🔥 prevent close inside
          >
            <GroupSecondary
              onClose={() => setShowGroupModal(false)}   // 🔥 cancel button
              onSave={(data) => {

                const newGroup = {
                  name: data.name,
                  depth: 1
                };

                setGroupList(prev => [...prev, newGroup]);

                setLedger(prev => ({
                  ...prev,
                  group: data.name
                }));

                setShowGroupModal(false);
              }}
            />
          </div>
        </div>
      )}

      </div>
    </div>
  );
}